import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegisterGoodsService {

  constructor(
    private http: HttpClient
  ) { }

  public uploadGoodsList(file: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        'contet-type': 'multipart/form-data',
      })
    };
    return this.http.post(environment.apiEndPoint + 'api/register-goods/upload-list', file, httpOptions) as Observable<any>;
  }

  public downloadGoodsList(fileName: string) {
    const httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),
      params: { 'fileName': fileName }
    };
    return this.http.get(environment.apiEndPoint + 'api/register-goods/download-list', httpOptions) as Observable<any>;
  }

  public downloadGoodsMaster(param: any): Observable<any> {
    const httpOptions: any = {
      responseType: 'blob',
      params: param
    };
    return this.http.get(environment.apiEndPoint + 'api/register-goods/download-master', httpOptions) as Observable<any>;
  }

  /**
   * 商品マスタテンプレートダウンロードAPI呼び出し
   */
  public downloadGoodsMasterTemplate(param: any): Observable<any> {
    const httpOptions: any = {
      responseType: 'blob',
      params: param
    };
    return this.http.get(environment.apiEndPoint + 'api/register-goods/download-master-template', httpOptions) as Observable<any>;
  }

  /**
   * 画面初期化API呼び出し
   */
  public initialize(organization: string): Observable<any> {
    const httpOptions: any = {
      params: {
        'organization': organization
      }
    };
    return this.http.get(environment.apiEndPoint + 'api/register-goods/initialize', httpOptions) as Observable<any>;
  }
}
